import { render, staticRenderFns } from "./LogoAlertaHidrica.vue?vue&type=template&id=d05d93d4&scoped=true"
import script from "./LogoAlertaHidrica.vue?vue&type=script&lang=ts"
export * from "./LogoAlertaHidrica.vue?vue&type=script&lang=ts"
import style0 from "./LogoAlertaHidrica.vue?vue&type=style&index=0&id=d05d93d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05d93d4",
  null
  
)

export default component.exports